<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.newCustomer.dialogTitle' | translate }}</h2>
            <button data-test="B-Close-dialog" type="button" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form>

            <mat-vertical-stepper linear (animationDone)="scrollTop()">

                <ng-template matStepperIcon="edit">
                    <mat-icon>edit</mat-icon>
                </ng-template>

                <mat-step [stepControl]="formGroup.get('tenant')">
                    <ng-template matStepLabel>{{ 'workflows.screens.newCustomer.stepCustomerData' | translate }}</ng-template>

                    <div class="py-16">
                        <form-widget-tenant [parentFormGroup]="formGroup"></form-widget-tenant>
                    </div>
                </mat-step>

                <mat-step [stepControl]="formGroup.get('user')">
                    <ng-template matStepLabel>{{ 'workflows.screens.newCustomer.stepAdminAccount' | translate }}</ng-template>

                    <div class="py-16">
                        <form-widget-tenant-admin-account
                                [parentFormGroup]="formGroup"></form-widget-tenant-admin-account>
                    </div>
                </mat-step>

            </mat-vertical-stepper>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Abbrechen" type="button" color="warn" mat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>

        <ng-template #saving>
            <mat-icon>save</mat-icon>
            <span>{{ 'workflows.screens.newCustomer.saveNewCustomer' | translate }}</span>
            <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
        </ng-template>

        <ng-template #notSaving>
            <mat-icon>save</mat-icon>
            {{ 'workflows.screens.newCustomer.saveNewCustomer' | translate }}
        </ng-template>

        <div class="button-group">
            <ng-container *ngIf="stepper?.selectedIndex === stepper?.steps?.length - 1; else continueButton">
                <ng-container *ngIf="stepper?.selectedIndex > 0">
                    <button mat-raised-button (click)="goBack()">
                        {{ 'common.back' | translate }}
                    </button>
                </ng-container>
                <button data-test="B-Speichern" type="button" mat-raised-button
                        (click)="save()"
                        class="save-button mat-accent ml-0"
                        [disabled]="!formGroup.dirty || isSaving"
                        [attr.aria-label]="'common.save' | translate">
                    <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
                </button>
            </ng-container>

            <ng-template #continueButton>
                <ng-container *ngIf="stepper?.selectedIndex > 0">
                    <button mat-raised-button (click)="goBack()">
                        {{ 'common.back' | translate }}
                    </button>
                </ng-container>
                <button mat-raised-button (click)="goForward()">
                    {{ 'common.continue' | translate }}
                </button>
            </ng-template>
        </div>

    </div>
</div>
